<template lang="pug">
  //- div(:style="{display:'block', textAlign:'center'}")
  //-   img(src='@/assets/img/fundDisabled.jpg' alt='usit photo' :style="{height:'40vh', borderLeftStyle:'solid'}")
  .content
    .md-layout.md-gutter.md-alignment-center-center(v-if="user.teaching_role != 'PM'")
      .md-layout-item.md-size-70.md-medium-size-85.md-xsmall-size-100
        FundOverview(v-if="user.fund" :groupID="user.fund")
        FundRegister(v-else :user="user")
    .md-layout.md-gutter.md-alignment-center-top(v-else)
      .md-layout-item.md-size-50.md-medium-size-85.md-xsmall-size-100
        FundOverview(:groupID="user.fund")
      .md-layout-item.md-size-50.md-medium-size-85.md-xsmall-size-100
        .md-layout-item.md-size-100
          FundRoster(:groupID="user.fund")
        .md-layout-item.md-size-100
          FundRequests(:groupID="user.fund")

</template>


<script>
import FundOverview from '@/pages/Fund/FundOverview.vue';
import FundRegister from '@/pages/Fund/FundRegister.vue';
import FundRoster from '@/pages/Fund/FundRoster.vue';
import FundRequests from '@/pages/Fund/FundRequests.vue';

export default {
  components: {
    FundOverview,
    FundRegister,
    FundRoster,
    FundRequests
  },
  data() {
    return {
      user: null,
    };
  },
  created() {
    this.user = this.$store.state.user;
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/Fund/FundLanding.vue